<template>
  <v-container fluid>
    
     <v-toolbar flat  color="#FAFAFA" >
      <!--v-toolbar-side-icon @click="$emit('showHideMenu')" ></v-toolbar-side-icon-->
      <v-toolbar-title >Produtos</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" light flat to="/produtos/adicionar">
      <v-icon left>add</v-icon>
      Adicionar</v-btn>
    </v-toolbar>
<v-divider></v-divider>
    <v-card flat>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field v-model="search" append-icon="search" label="Busca" single-line hide-details></v-text-field>
      </v-card-title>

      <v-data-table :custom-filter="data_search" :headers="headers" :items="products" :search="search" :rows-per-page-items='[20,50,100,{"text":"Todas","value":-1}]'>
        <template slot="items" slot-scope="props">
          <td>{{ props.item.name }}</td>
          <td class="text-xs-left">{{ props.item.upc }}</td>
          <td class="text-xs-left">{{ props.item.artist_name }}</td>
          <td class="text-xs-left">{{ props.item.type_text }}</td>
          <td class="text-xs-left">{{ props.item.tracks_lenghts }}</td>
          <td class="text-xs-left">{{ props.item.status }}</td>
          <td>
            <v-menu offset-x  bottom>
              <v-btn icon slot="activator">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile  :to="{name:'produtos_editar', params:{ id:props.item.id} }">
                  <v-list-tile-title><v-icon>assignment</v-icon> Editar Metadados</v-list-tile-title>
                </v-list-tile> 
                <v-list-tile  :to="{name:'produtos_auditie', params:{ id:props.item.id} }">
                  <v-list-tile-title><v-icon>audiotrack</v-icon> Gerenciar Áudios</v-list-tile-title>
                </v-list-tile>                
              </v-list>
            </v-menu>
          </td>
        </template>

        <v-alert
          slot="no-results"
          :value="true"
          color="error"
          icon="warning"
        >Você buscou por "{{ search }}" e não encontramos nenhum resultado.</v-alert>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import ProductService from "../app/Rest/product";

var productService = null;

export default {
  data() {
    return {
      search: "",
      products: [],
      headers: [
        {
          text: "Album",
          align: "left",
          sortable: true,
          value: "name"
        },
        { text: "Código de barras",  align: "left", value: "upc" },
        { text: "Artista Principal", value: "artist_name" },
        { text: "Tipo", value: "type_text" },
        { text: "Qtd Faixas", value: "tracks_lenghts" },
        { text: "Status", value: "status" },
        { text: "Ações", value:'acoes'},
       
      ]
      
    };
  },
   computed: {
    ...mapGetters([     
      'artistas'
    ])
  },
  methods: {
    data_search(items, search, filter){
      //para melhorar a busca coloco tudo em caixa baixa
      var search_low = search.toLowerCase();
      return items.filter( item=> { 
        
        if(!item.artist_name)
          return false;

          //buscando no nome do artista
          if( item.name.toLowerCase().indexOf(search_low) >=0 )
            return true;
          if( item.upc.indexOf(search_low) >=0 )
            return true;
          if( item.artist_name.toLowerCase().indexOf(search_low) >=0 )
            return true;
          if( item.type_text.toLowerCase().indexOf(search_low) >=0 )
            return true;

          return false;

      } );
     
    },
    get_artist_by_id(id){      
      return this.artistas.find( artista=> artista.id === id).name;
    },
    load_products(){
      productService.search().then( e=>{
        //retornar o nome do artista da consulta
        this.products = e.items;//.map( ee=> { ee.artist_name = this.get_artist_by_id(ee.main_artist); return ee;});
        
      })
    }
  },
  created: function(){
    productService = ProductService.build();
    this.load_products();
  }
};
</script>
